import { Field } from '@sgdocs/client/lib';
import React, { ReactElement, useState } from 'react';
import { getFieldTitle } from '../../common/field/fields';
import { ILabels } from '../SGMDocsDocumentSorting';

export interface ISGMDocsDocumentSortingParameterProps {
  id: number;
  label: string;
  searchableFields: Field[];
  selected?: ISortingParameter;
  onChanged: (sorting: ISortingParameter) => void;
  modelJsonSchema?: any;
  labels: ILabels;
}

export interface ISortingParameter {
  id: number;
  fieldName: string;
  ascending: boolean;
}

export const SGMDocsDocumentSortingParameter: React.FC<ISGMDocsDocumentSortingParameterProps> = ({
  id,
  label,
  searchableFields,
  selected,
  onChanged,
  modelJsonSchema,
  labels,
}: ISGMDocsDocumentSortingParameterProps): ReactElement => {
  const [sortingParameter, setSortingParameter] = useState<ISortingParameter>({
    id: id,
    fieldName: '',
    ascending: true,
  });

  if (selected && selected.fieldName !== sortingParameter.fieldName) {
    setSortingParameter(selected);
  }

  const handleSortChange = (fieldName: string): void => {
    const newSortingParameter = { ...sortingParameter };
    newSortingParameter.fieldName = fieldName;
    setSortingParameter(newSortingParameter);
    onChanged(newSortingParameter);
  };

  const handleOrderChange = (ascending: boolean): void => {
    const newSortingParameter = { ...sortingParameter };
    newSortingParameter.ascending = ascending;
    setSortingParameter(newSortingParameter);
    onChanged(newSortingParameter);
  };

  const removeSort = (): void => {
    const newSortingParameter = { ...sortingParameter };
    newSortingParameter.fieldName = '';
    setSortingParameter(newSortingParameter);
    onChanged(newSortingParameter);
  };

  const buildLabel = (fieldName: string): string => {
    return fieldName ? getFieldTitle(fieldName, modelJsonSchema) : '';
  };

  function isAscending(): boolean {
    return sortingParameter.ascending;
  }

  return (
    <div className="form-group">
      <label>{label}</label>
      <div className={'d-flex'} style={{ maxHeight: '32px' }}>
        <select
          className="form-control fw-medium me-2"
          style={{ color: sortingParameter.fieldName ? '#2469ff' : 'rgba(0,0,0,.4)' }}
          value={selected?.fieldName}
          onChange={(event): void => {
            if (event.target.value) {
              event.target.style.setProperty('color', '#2469ff'); // text-info color
              handleSortChange(event.target.value);
            } else {
              event.target.style.setProperty('color', 'rgba(0,0,0,.4)'); // text-muted color
              removeSort();
            }
          }}
        >
          <option className={'text-muted'} value="">
            {labels.searchAndSelect}
          </option>
          {searchableFields.map((sf) => (
            <option key={`sgmDocsDocumentSortingParameter-${id}-${sf.name}`} style={{ color: 'black' }} value={sf.name}>
              {buildLabel(sf.name)}
            </option>
          ))}
        </select>

        <div className="btn-group btn-group-toggle" data-toggle="buttons" role="group">
          <button
            className={'btn btn-sm btn-toggle-primary ' + (isAscending() ? 'active' : '')}
            onClick={(): void => handleOrderChange(true)}
            title={labels.ascending}
          >
            <i className={'icon icon-sm'}>arrow_upward</i>
          </button>
          <button
            className={'btn btn-sm btn-toggle-primary ' + (!isAscending() ? 'active' : '')}
            onClick={(): void => handleOrderChange(false)}
            title={labels.descending}
          >
            <i className={'icon icon-sm'}>arrow_downward</i>
          </button>
        </div>
      </div>
    </div>
  );
};
